module.exports = "<ngx-loading-bar [color]=\"'blue'\"></ngx-loading-bar>\n<router-outlet></router-outlet>\n"